import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

export function NotFound() {
  useSEO({
    title: 'Page introuvable',
    description: "Cette page n'existe pas — ou plus.",
  });

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        padding: '64px 24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <p
          style={{
            fontFamily: "'JetBrains Mono', ui-monospace, monospace",
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: '#C8102E',
            marginBottom: 16,
          }}
        >
          404 · Introuvable
        </p>
        <h1 style={{ fontFamily: "'Fraunces', serif", fontWeight: 500, fontSize: 40, lineHeight: 1.1 }}>
          Cette page <em>s'est égarée</em>.
        </h1>
        <p style={{ marginTop: 16, color: 'rgba(15,25,22,0.6)' }}>
          Le lien que vous avez suivi ne pointe vers rien sur ce site. Le programme 2026 vous attend
          juste en dessous.
        </p>
        <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'center' }}>
          <Link to="/" className="mtc-btn mtc-btn-primary">
            Retour à l'accueil
          </Link>
          <Link to="/formations" className="mtc-btn mtc-btn-ghost">
            Voir les formations →
          </Link>
        </div>
      </div>
    </div>
  );
}
